import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100px);
  }

  50% {
    opacity: 0;
    transform: translateY(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MainContainerAnimation = styled.div`
  animation: ${slideUp} 0.5s ease-in;
  width: 100%;
`;
